const PUBLISHABLE_KEY = /^pk_(test|live)_[A-Za-z0-9]+$/;

export function resolveStripePublishableKey(value: unknown): string {
  if (typeof value !== 'string') {
    throw new Error('Stripe publishable key is missing');
  }

  const key = value.trim();
  if (!key) {
    throw new Error('Stripe publishable key is missing');
  }
  if (key.startsWith('sk_')) {
    throw new Error('Stripe key must be publishable (pk_), not a secret key');
  }
  if (!PUBLISHABLE_KEY.test(key)) {
    throw new Error('Stripe publishable key is invalid');
  }
  return key;
}
